import  VueI18n  from "vue-i18n"
import Vue from 'vue'
import messages from "./index"
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import viLocale from 'element-ui/lib/locale/lang/vi'
import en_us from "./en_us.json";
import zh_cn from "./zh_cn.json";
import vi_vn from "./vi_vn.json";
Vue.use(VueI18n);
const language = (navigator.language || "en").toLocaleLowerCase() // 这是获取浏览器的语言
 
// function getLocale(lan) {
//   return lan.match(/ar/g) ? "ar" : lan.match(/tr/g) ? "tr" : "en" // 优先选中阿拉伯语
// }
const message={
  en_us:{
    ...en_us,...enLocale
  },zh_cn:{
    ...zh_cn,...zhLocale
  },vi_vn:{
    ...vi_vn,...viLocale
  },
}
  const i18n=new VueI18n({
    locale: sessionStorage.getItem("vc_lang")?sessionStorage.getItem("vc_lang"):'zh_cn',
    fallbackLocale: "en", // 设置备用语言
    messages:message,
    globalInjection:true
  })
export default i18n;